export enum JobStatus {
  Pending = 'PENDING',
  Started = 'STARTED',
  Archived = 'ARCHIVED',
  Finished = 'FINISHED',
  Invalid = 'INVALID'
}
